import { cn } from '@/lib/utils'

/**
 * Status chip — Plex Mono 11px, normal case, flat tint + hairline border.
 * Purely presentational: labels AND color classes come from src/lib/status.ts
 * (single source) — never pick chip colors at a call site.
 */
export function StatusChip({
  label,
  chipClasses,
  className,
}: {
  label: string
  chipClasses: string
  className?: string
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded-xs border px-1.5 py-0.5 font-mono text-[11px] font-medium',
        chipClasses,
        className,
      )}
    >
      {label}
    </span>
  )
}
